// extracted by mini-css-extract-plugin
module.exports = {"lightbulb":"Lightbulb_lightbulb__VCpbZ","bubble":"Lightbulb_bubble__9pwj4","bubble__wrapper":"Lightbulb_bubble__wrapper__stRN1","light_bubble":"Lightbulb_light_bubble__TcROf"};